<template>
  <el-table-column
    prop="pack_type_name"
    label="Kiszerelés"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.pack_type_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'pack_type_name',
};
</script>
